import { ITagsData } from "src/api/server/extended-search";
import { ITagValue } from "../components/types";
import { EnumSearchQueryParams } from "../search.types";

export const mapTagsFromQuery = (urlParams: URLSearchParams, tagsData: ITagsData): ITagValue[] => {
    const selectedTags = urlParams.get(EnumSearchQueryParams.Tags)?.split(",") ?? [];
    const allTags = [
        ...tagsData.tags.basics.tags,
        ...tagsData.tags.rewards.tags,
        ...tagsData.tags.tradings.tags,
        ...tagsData.tags.investmentHorizon.tags,
        ...tagsData.tags.investmentRegion.tags,
        ...tagsData.tags.alphaBeta.tags,
    ];

    return allTags.flatMap(filterTag =>
        selectedTags.includes(filterTag.urlIdentifier)
            ? [
                  {
                      value: filterTag.urlIdentifier,
                      isPopular: filterTag.isPopular ?? false,
                  },
              ]
            : []
    );
};

export const mapTagsToQuery = (tags: readonly ITagValue[]) => {
    return tags && tags.length > 0 ? `${EnumSearchQueryParams.Tags}=${tags.map(tag => tag.value).join(",")}` : "";
};
